export default [
  { code: 'id', name: 'id', type: 'id' },
  {
    code: 'organisation',
    name: 'organisation',
    type: 'select',
    dictionary: 'organization',
    itemValue: 'id',
    itemText: 'shortName',
  },
  { code: 'amount', name: 'amount', type: 'input', isNumber: true },
  // { code: 'time', name: 'time', type: 'input' },
  { code: 'temperature', name: 'temperature', type: 'input', isNumber: true },
  { code: 'document', name: 'document', type: 'input' },
  {
    code: 'goods',
    name: 'goods',
    type: 'select',
    dictionary: 'goods',
    itemValue: 'id',
    itemText: 'shortName',
  },
  {
    code: 'serial',
    name: 'plugGuid',
    type: 'select',
    isUuid: true,
    dictionary: 'devices',
    itemValue: 'serial',
    itemText: 'serial',
  },
  { code: 'delta', name: 'delta', type: 'input', isNumber: true },
  {
    code: 'shipment',
    name: 'shipment',
    type: 'select',
    dictionary: 'boolean',
    itemValue: 'code',
    itemText: 'name',
  },
  {
    code: 'offs',
    name: 'offs',
    type: 'select',
    dictionary: 'boolean',
    itemValue: 'code',
    itemText: 'name',
  },
]
